<div class="select-wrapper single-select">
  <div #selectTrigger class="select-input form-control d-flex align-items-center justify-content-between"
    role="button" (click)="open()" [class.disabled]="disabled" (keydown)="handleKeydown($event)"
    [title]="selectedLabels().length ? selectedLabels()[0] : ''">

    <div class="zn-select-trigger">
      <input
        #searchInput
        type="text"
        class="form-control"
        [placeholder]="inputPlaceholderValue()"
        [value]="inputValue()"
        (input)="onSearchChange($any($event.target).value)"
        (focus)="onFocus(); open()"
        (blur)="onBlur()"
        (keydown)="handleKeydown($event)"
      />
      <button type="button" class="zn-select-action btn btn-tertiary" (click)="onRightIconClick($event)" (keydown.enter)="onRightIconClick($event)">
        @if (rightIcon() === 'chevron') {
        <i class="bi bi-chevron-down"></i>
        }

        @if (rightIcon() === 'refresh') {
        <i class="bi bi-arrow-clockwise"></i>
        }

        @if (rightIcon() === 'clear') {
        <i class="bi bi-x-lg"></i>
        }
      </button>
    </div>
  </div>
</div>

<ng-template #dropdownTemplate>
  <div
    class="zn-dropdown-menu dropdown-menu show custom-dropdown"
    (keydown)="handleKeydown($event)"
    [class.open-up]="openUp"
  >
    <div class="zn-dropdown-menu-body" (scroll)="onOptionsScroll($event)">
      @if (loading()) {
        <div class="zn-text-disabled">{{ localizationResource() + '::ZnSelectLoading' | abpLocalization }}</div>
      }

      @if (!loading() && filteredOptions().length === 0) {
        <div class="zn-text-disabled">{{ localizationResource() + '::ZnSelectResultNotFound' | abpLocalization }}</div>
      }

      @for (option of filteredOptions(); track option.key) {
        <div
          class="option-item d-flex align-items-center"
          (click)="onOptionClick($event, option.key)"
          [class.selected]="isSelected(option.key)"
          [class.active]="isActiveIndex($index)"
          [attr.tabindex]="isActiveIndex($index) ? 0 : -1"
        >
          <span [title]="toLocalizationKey(option.value) | abpLocalization">{{ toLocalizationKey(option.value) | abpLocalization }}</span>
        </div>
        <hr class="zn-separator">
      }

      @if (loadingMore()) {
       <zn-button 
              [label]="`${localizationResource()}::ZnSelectLoading` | abpLocalization"
              type="tertiary"
              size="normal"
              loading="true"
              disabled="true"
              loadingIconPosition="left"></zn-button>
      }
    </div>
  </div>
</ng-template>
